import * as semrush from '@anm/helpers/semrush';
export var getUpgradeLinkProps = function getUpgradeLinkProps() {
  var upgradeLink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/pricing';
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_blank';
  var isSemrush = semrush.isSemrushIframe();
  return isSemrush ? {
    onClick: semrush.requestPurchase
  } : {
    href: upgradeLink,
    target: target
  };
};
export var getLinkTarget = function getLinkTarget() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '_blank';
  return semrush.isSemrushIframe() ? '_self' : target;
};